Vue.component('content-examples', {
    delimiters: ['[[', ']]'],
    template: `
        <div>
            <div class="row d-flex flex-wrap align-items-center">

                <div
                class="lqd-column col-md-5 mb-30"
                data-custom-animations="true"
                data-ca-options='{"triggerHandler":"inview", "animationTarget":"all-childs", "duration":"1600", "delay":"160", "easing":"easeOutQuint", "direction":"forward", "initValues":{"translateY":30, "opacity":0}, "animations":{"translateY":0, "opacity":1}}'>

                    <header class="fancy-title pr-md-4">
                        <h6 class="text-uppercase">Some examples</h6>
                        <h2><strong>Great solutions</strong> for you</h2>
                    </header>

                    <p class="font-size-18 lh-15 mb-55">This is a non-exhaustive list of services you can enjoy as a <span class="sq-font" style='color:black;'>SpartaQuant</span> user</p>

                    <a
                    href="https://www.spartaquant.pro"
                    target="_blank"
                    class="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient font-weight-bold px-2"
                    >
                        <span>
                            <span class="btn-gradient-bg"></span>
                            <span class="btn-txt">Start now</span>
                            <span class="btn-gradient-bg btn-gradient-bg-hover"></span>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" class="btn-gradient-border" width="100%" height="100%">
                                <defs>
                                    <linearGradient id="svg-border-3" x1="0%" y1="0%" x2="100%" y2="0%">
                                        <stop offset="0%"></stop>
                                        <stop offset="100%"></stop>
                                    </linearGradient>
                                </defs>
                                <rect x="0.5" y="0.5" rx="29.5" ry="29.5" width="100%" height="100%" stroke="url(#svg-border-3)"></rect>
                            </svg>
                        </span>
                    </a>

                </div><!-- /.lqd-column col-md-5 -->

                <div
                class="lqd-column col-md-3 col-md-offset-1"
                >

                    <div
                    class="lqd-column-inner"
                    data-parallax="true"
                    data-parallax-from='{"translateY":-30}'
                    data-parallax-to='{"translateY":120}'
                    data-parallax-options='{"duration":"2000", "easing":"linear", "reverse":true, "triggerHook":"onEnter", "overflowHidden": false}'>

                        <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
                            <div class="iconbox-icon-wrap">
                                <span class="iconbox-icon-container mb-35 text-neon-carrot">
                                    <i class="fa fa-line-chart"></i>
                                </span>
                            </div><!-- /.iconbox-icon-wrap -->
                            <div class="contents">
                                <h3>Market regime indicator</h3>
                                <p class="font-size-16 lh-165">This is an example of an econometric model for identifying equity market trends</p>
                            </div><!-- /.contents -->
                        </div><!-- /.iconbox -->

                        <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
                            <div class="iconbox-icon-wrap">
                                <span class="iconbox-icon-container mb-35 text-neon-carrot">
                                    <i class="fa fa-search"></i>
                                </span>
                            </div><!-- /.iconbox-icon-wrap -->
                            <div class="contents">
                                <h3>Equity index analysis</h3>
                                <p class="font-size-16 lh-165">This is an example of a <span class="sq-font" style='color:black;'>SpartaQuant</span> application that analyses the Eurostoxx index and highlights the companies which are trending</p>
                            </div><!-- /.contents -->
                        </div><!-- /.iconbox -->
                        
                    </div><!-- /.lqd-column-inner -->

                </div><!-- /.lqd-column col-md-3 -->

                <div class="lqd-column col-md-3">

                    <div
                    class="lqd-column-inner"
                    data-parallax="true"
                    data-parallax-from='{"translateY":50}'
                    data-parallax-to='{"translateY":-130}'
                    data-parallax-options='{"duration":"2000", "easing":"linear", "reverse":true, "triggerHook":"onEnter", "overflowHidden": false}'>

                        <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
                            <div class="iconbox-icon-wrap">
                                <span class="iconbox-icon-container mb-35 text-neon-carrot">
                                    <i class="fa fa-wifi"></i>
                                </span>
                            </div><!-- /.iconbox-icon-wrap -->
                            <div class="contents">
                                <h3>Web scraping</h3>
                                <p class="font-size-16 lh-165">This is an example of a function that web scrapes information related to company ratings and employee reviews</p>
                            </div><!-- /.contents -->
                        </div><!-- /.iconbox -->

                        <div class="iconbox text-left iconbox-round iconbox-lg iconbox-filled iconbox-filled iconbox-filled-hover iconbox-icon-image iconbox-shadow pt-50 pb-40">
                            <div class="iconbox-icon-wrap">
                                <span class="iconbox-icon-container mb-35 text-neon-carrot">
                                    <i class="fa fa-globe"></i>
                                </span>
                            </div><!-- /.iconbox-icon-wrap -->
                            <div class="contents">
                                <h3>OECD</h3>
                                <p class="font-size-16 lh-165">This is an example of a function that web scrapes macro-economic data from the OECD</p>
                            </div><!-- /.contents -->
                        </div><!-- /.iconbox -->

                    </div><!-- /.lqd-column-inner -->

                </div><!-- /.lqd-column col-md-3 -->

            </div><!-- /.row -->
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
        }
    },
    mounted(){

    },
    methods: {
        test: function(){

        }
    },
});